// BlogPost1Page.js
import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/photo2.jpg";
import pr1 from "../images/misunderstood1.jpg";
import pr2 from "../images/misunderstood2.jpg";
import { motion } from 'framer-motion';




const BlogPost2Page = ({ post }) => {
    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Do you often misunderstand native speakers?
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Improving listening skills in <i><b>English as a second language relies on recognizing and understanding English phonetics. </b></i>And yet this skill was largely neglected in the past and many students missed this part entirely. Those same students need English nowadays at work, to pass TOEIC to apply for a student visa abroad to get promoted at work.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Adults will have twice as much trouble mastering English pronunciation compared with students who are much younger and can learn how to form the phonemes correctly much easier.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                After all, it’s a very specific skill that enables you to accurately <i><b>perceive spoken words and comprehend the intended meaning.</b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Let’s check some ways phonetic understanding helps in listening:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>

                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }} >
                        <i><b>Sound Discrimination:</b></i> Being familiar with English phonetics helps learners differentiate between similar sounds, preventing confusion. For example, distinguishing between the vowels <i><b>/æ/ (as in "cat") and /ʌ/ (as in "cut")</b></i> ensures comprehension of words like "man" and "men."
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <i><b>Connected Speech:</b></i> English speakers often<i><b> blend words together in connected speech,</b></i> altering their pronunciation. Understanding phonetics helps learners distinguish these connected speech patterns.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        For instance, recognizing that the <i><b>"t" in "next time"</b></i> often becomes a flap /ɾ/ sound helps learners<u> understand native speakers when they say it quickly.</u>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <i><b>Word Stress and Sentence Intonation:</b></i> Recognizing word stress and sentence intonation supports your overall understanding and context. For example, knowing that content words are typically stressed in English sentences <i><b>assists you in identifying key information.</b></i>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        As you can see, mastering English phonetics enhances your listening skills, and enables you to communicate effectively in real-life situations and avoid misunderstandings.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        We offer many tips and advice on how you can improve your listening skills and you’re most welcome to check them on our YouTube channel (link).
                    </Typography>
                    <Grid item xs={12} lg={11} container spacing={2}>
                        <Grid item xs={6} paddingBottom={'20px'}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                    <CardMedia
                                        component="img"
                                        image={pr1}
                                        alt="Fresh Start"
                                        sx={{ borderRadius: 2 , height: 300 , marginTop : '10px'}}
                                    />
                            </motion.div>
                        </Grid>
                        <Grid item xs={6}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                    <CardMedia
                                        component="img"
                                        image={pr2}
                                        alt="Fresh Start"
                                        sx={{ borderRadius: 2 , height: 300 , marginTop : '10px'}}
                                    />
                            </motion.div>
                        </Grid>
                    </Grid>

                </Container >
            </Box >
        </>
    );
};

export default BlogPost2Page;
